import { createSelector } from '@ngrx/store';
import { IAppState } from 'src/app/modules/shared/ngrx.stores/frontend.settings/states';

export const selectFeature = (state: IAppState) => state.placeQueryCommand;

export const placeQueryCommandSelector = createSelector(
  selectFeature,
  (state) => state?.command
);
